<!--
Author: Lsc
Date: 2019-9-11
Desc: 盈亏查询组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-profit-qry bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/fund' }">
                    基金交易
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <div class="statement-content">
            <el-row class="statement-filter">
                <el-col :span="24">
                    <el-button
                        type="yellow"
                        class="print-btn right"
                        v-on:click.prevent="getProfitList"
                    >
                        查询
                    </el-button>
                    <div class="right">
                        <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                    </div>
                    <span class="right date-text">
                        选择日期区间：
                    </span>
                </el-col>
            </el-row>
            <div class="table-title">
                持有基金：
            </div>
            <el-table
                :data="profitList"
                border
                style="width: 100%"
            >
                <el-table-column
                    prop="fundcode"
                    label="基金名称"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="beginfundmkt"
                    label="初始市值"
                    width="120"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="期间投入"
                    align="center"
                >
                    <el-table-column
                        prop="periodbuyamt"
                        label="认/申购"
                        width="120"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="periodconvertamt"
                        label="转换入"
                        width="120"
                        align="center"
                    >
                    </el-table-column>
                </el-table-column>
                <el-table-column
                    label="期间所得"
                    align="center"
                >
                    <el-table-column
                        prop="periodredeemamt"
                        label="赎回/转换出"
                        width="120"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="periodcashamt"
                        label="分红"
                        width="120"
                        align="center"
                    >
                    </el-table-column>
                </el-table-column>
                <el-table-column
                    prop="endfundmkt"
                    label="期末市值"
                    width="120"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="periodincome"
                    label="期间收益"
                    width="120"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="periodyield"
                    label="收益率"
                    width="120"
                    align="center"
                >
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import format from "date-fns/format";
import datePicker from "@/components/form/datePicker";
export default {
    name: "Statement",
    components: {
        datePicker
    },
    mixins: [mixin],
    data () {
        return {
            qryArea: {
                fundcode: "",
                begindate: "", // 默认起始日期
                enddate: "" // 默认结束日期
            },
            dateArr: [],
            pickerOptions: {
                disabledDate: time => {
                    return time.getTime() > new Date().getTime();
                }
            },
            dateSet: { type: "2", min: "1990-01-01", size: "media",val: [] },
            profitList: []
        };
    },
    mounted () {
        this.nowDate = format(new Date(), "YYYYMMDD");
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.qryArea.begindate = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 1);
        this.qryArea.enddate = this.nowDate;
        const _x = this.$util.fmtDate(this.qryArea.begindate);
        const _y = this.$util.fmtDate(this.qryArea.enddate);
        this.dateSet.val = [_x,_y];
        this.getProfitList();
    },
    created () {
    },
    methods: {
        // 获取用户选中时间区间
        dateInterval (val) {
            this.qryArea.begindate = this.$util.isEmpty(val.beginDate) ? "" : val.beginDate.replace(/-/g, "");
            this.qryArea.enddate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        getProfitList (val) {
            const _this = this;
            if(this.$util.isEmpty(this.qryArea.begindate) || this.$util.isEmpty(this.qryArea.enddate)){
                _this.profitList = [];
                let _m = "请输入完整的日期范围";
                this.$alert(_m,"日期提示");
                return;
            }
            this.$util.request("acct/asset/profitandloss", this.qryArea, "GET", false).then(res => {
                if (res.data) {
                    _this.profitList = res.data;
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-profit-qry {
    padding-bottom: 50px;
    .date-text{line-height: 40px;margin-right: 10px;}
    .statement-content {
        padding: 0px 20px;
        .statement-form {
            padding: 10px 0px;
            border-bottom: 1px solid #ebebeb;
            >div {
                padding:5px;
            }
        }
        .statement-filter {
            text-align: right;
            padding: 10px 0px;
            .print-btn {
                margin-left: 10px;
            }
        }
        .table-title {
            padding: 10px 0px;
        }
    }
}
</style>
